import React from 'react'
import numbro from 'numbro'
import Icon from 'constructicon/icon'
import Metric from 'constructicon/metric'

const TotalDonations = ({
  label,
  format,
  funded,
  metric,
  multiplier,
  projects,
  offset,
  notFunded,
  status,
  ...props
}) => {
  const getAmount = () => {
    switch (status) {
      case 'fetching':
        return <Icon name='loading' spin />
      case 'failed':
        return <Icon name='warning' />
      default:
        const donations = projects.reduce((total, project) => total + project.totalDonations, 0)
        return numbro((donations + offset) * multiplier).format(format)
    }
  }

  return (
    <Metric
      amount={getAmount()}
      label={label}
      {...metric}
      {...props}
    />
  )
}

export default TotalDonations



// WEBPACK FOOTER //
// ./components/slices/ProjectMetrics/TotalDonations/index.js